import ProductsRepository from './ProductsRepository.js'

/**
 * @interface
 */
export default class HTTPProductsRepository extends ProductsRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.authenticationFetcher
   * @param {Object} deps.productsRawDataToVisibilityProductsListVOMapper
   * @param {Object} deps.productRawDataToProductEntityMapper
   * @param {Object} deps.getProductsError
   * @param {Object} deps.getVisibilityProductsError
   */
  constructor({
    config,
    authenticationFetcher,
    productsRawDataToVisibilityProductsListVOMapper,
    productRawDataToProductEntityMapper,
    getProductsError,
    getVisibilityProductsError,
    getPaymentAdProductsError
  }) {
    super()
    this._config = config
    this._authenticationFetcher = authenticationFetcher
    this._productsRawDataToVisibilityProductsListVOMapper = productsRawDataToVisibilityProductsListVOMapper
    this._productRawDataToProductEntityMapper = productRawDataToProductEntityMapper
    this._getProductsError = getProductsError
    this._getVisibilityProductsError = getVisibilityProductsError
    this._getPaymentAdProductsError = getPaymentAdProductsError
  }

  /**
   * @method
   * @return {Promise}
   */
  _getProducts({params}) {
    return this._authenticationFetcher.get(`${this._config.get('API_URL')}/v2/products/`, {
      params
    })
  }

  /**
   * @method
   * @return {Object}
   */
  // ff_web_seller_make_available_visibility_products_pack
  _getParams({adPrice, isVisibilityProduct, isPaymentAd, variant}) {
    const store = this._config.get('DEFAULT_STORE_ID')
    const defaultParams = {store}
    if (adPrice) {
      defaultParams.adPrice = adPrice
    }
    // ff_web_seller_make_available_visibility_products_pack
    if (isVisibilityProduct) return {...defaultParams, isVisibilityProduct, variant}
    if (isPaymentAd) return {...defaultParams, isPaymentAd}
  }

  /**
   * @method
   * @return {Promise}
   */
  // ff_web_seller_make_available_visibility_products_pack
  async getVisibilityProducts({userId, adId, adPrice, visibilityPackVariant}) {
    const params = this._getParams({
      adPrice: adPrice ?? 20000, // PARAM TO BE REMOVED: JUST A QUICK FIX PENDING TO BE SOLVED ON BACKEND SIDE
      isVisibilityProduct: true,
      // ff_web_seller_make_available_visibility_products_pack
      ...(visibilityPackVariant && {variant: `testCombo`})
    })

    try {
      const {data: productsList} = await this._getProducts({params})
      const visiblityProductsValueObject = this._productsRawDataToVisibilityProductsListVOMapper.map({
        productsList
      })
      return visiblityProductsValueObject
    } catch (error) {
      throw this._getVisibilityProductsError(
        '[HTTPProductsRepository#getVisibilityProducts] Get VisibilityProducts error'
      )
    }
  }

  /**
   * @method
   * @return {Promise}
   */
  async getPaymentAdProduct({userId, adId}) {
    const params = this._getParams({
      isPaymentAd: true,
      adPrice: 400 // PARAM TO BE REMOVED: JUST A QUICK FIX PENDING TO BE SOLVED ON BACKEND SIDE
    })
    try {
      const {
        data: [product]
      } = await this._getProducts({params})
      const paymentAdEntity = this._productRawDataToProductEntityMapper.map(product)
      return paymentAdEntity
    } catch (error) {
      throw this._getPaymentAdProductsError('[HTTPProductsRepository#getPaymentAdProduct] Get PaymentAdProduct error')
    }
  }

  /**
   * @method
   * @return {Promise}
   */
  async getAdProducts({adId, userId}) {
    try {
      const {
        data: {products: productsList}
      } = await this._authenticationFetcher.get(`${this._config.get('API_URL')}/user/${userId}/ads/${adId}`)
      const visiblityProductsValueObject = this._productsRawDataToVisibilityProductsListVOMapper.map({
        productsList
      })
      return visiblityProductsValueObject
    } catch (error) {
      throw this._getVisibilityProductsError(
        '[HTTPProductsRepository#getVisibilityProducts] Get VisibilityProducts error'
      )
    }
  }
}
